module.exports = __webpack_public_path__ + "static/img/Liam-Martin.22b7505.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Liam-Martin.jpg
// module id = nyEw
// module chunks = 0